export default "/images/27e8d53e14ea4bf3cb579411cf8cba64.avif";